module.exports = require("accounting");


//////////////////
// WEBPACK FOOTER
// external "accounting"
// module id = 22
// module chunks = 0